export interface IdNameDto {
  id: string;
  name: string;
}
